import axios from 'axios';

let API_URL = 'https://api.loopic.io/';

if (process.env.REACT_APP_DEV_ENV === 'local') {
  API_URL = 'http://localhost:5000';
} else if (process.env.REACT_APP_DEV_ENV === 'remote') {
  API_URL = 'https://loopic-dev.herokuapp.com/';
}

const apiClient = axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use(
  (config) => {
    return {
      ...config,
    };
  },
  (error) => Promise.reject(error),
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    return Promise.reject(error.response.data);
  },
);

const { get, post, put, delete: destroy } = apiClient;
export { get, post, put, destroy };
